export const tramites = [
    {
        "anio" : "Procedimientos de Contratación 2025",
       
        "tramitesLista" : [
            {
                 "nombre" : "Convocatoria No. EO-SIPDUS-N5-2025, -----Proyecto Integral para la Construcción del Centro Administrativo y de Servicios para el pueblo (CASP), en el municipio de Pachuca de Soto, ubicado en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo. ",

                "descripcion" : "Proyecto Integral para la Construcción del Centro Administrativo y de Servicios para el pueblo (CASP), en el municipio de Pachuca de Soto, ubicado en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.",
                               
                "contenidoTramite" : [
                  
                    {
                        "nombre" : "Junta de Aclaraciones",
                         "url" : "/interes/contratacion/JuntaAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Anexo Modificatorio",
                        "url" : "/interes/contratacion/AnexoModificatorio.pdf"
                    },
                    {
                        "nombre" : "Apertura de Proposiciones",
                       "url" : "/interes/contratacion/apertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                       "url" : "/interes/contratacion/fallo.pdf"
                    }
                ]
            },

            //   {
            //      "nombre" : "Convocatoria No. EO-SIPDUS-N5-2025 ",

            //     "descripcion" : "Proyecto Integral para la Construcción del Centro Administrativo y de Servicios para el pueblo (CASP), en el municipio de Pachuca de Soto, ubicado en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.",
                               
            //     "contenidoTramite" : [
                  
            //         {
            //             "nombre" : "Junta de Aclaraciones",
            //              "url" : "/interes/contratacion/JuntaAclaraciones.pdf"
            //         },
            //         {
            //             "nombre" : "Anexo Modificatorio",
            //             "url" : "/interes/contratacion/AnexoModificatorio.pdf"
            //         },
            //         {
            //             "nombre" : "Apertura de Proposiciones",
            //            "url" : "/interes/contratacion/apertura.pdf"
            //         },
            //         {
            //             "nombre" : "Fallo",
            //            "url" : "/interes/contratacion/fallo.pdf"
            //         }
            //     ]
            // }
        ]

    }
    
]